import { render, staticRenderFns } from "./SearchByFace.vue?vue&type=template&id=1c81b2a8&scoped=true"
import script from "./SearchByFace.vue?vue&type=script&lang=js"
export * from "./SearchByFace.vue?vue&type=script&lang=js"
import style0 from "./SearchByFace.vue?vue&type=style&index=0&id=1c81b2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81b2a8",
  null
  
)

export default component.exports